import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: клик по логотипу ПИК (переход к началу страницы / якорь вверх).
 */
export function trackPikLogoClick(): void {
  ca('eventSite', {
    action: 'click_pik_logo',
    category: 'Promo',
    label: 'scroll_top',
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
